/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { filterObj } from 'utils';
import { CardButton, CardItem, CardHeader, CardTitle, StyledCard } from './styles';

const CardVaga = ({ vaga }) => {
  const constantes = useSelector(state => state.constantes);
  return (
    <StyledCard>
      <CardHeader>
        <div className="label">
          {filterObj(constantes.regime_de_contratacao, vaga.regime_de_contratacao)}
        </div>
        <CardTitle>{vaga.titulo}</CardTitle>
        {vaga.vaga_para_portadores_de_necessidades_especiais && (
          <div className="pcd-label">PCD</div>
        )}
      </CardHeader>
      <StyledCard.Body className="d-flex justify-content-between">
        <CardItem>
          <p className="w-100">Salário</p>
          <span>{vaga.salario} </span>
        </CardItem>
        <CardItem>
          <br />
          <CardButton as={Link} to={`/vaga/${vaga.id}`}>
            Ver detalhes
          </CardButton>
        </CardItem>
      </StyledCard.Body>
    </StyledCard>
  );
};

export default CardVaga;
